import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const requestOTPService = async (baseURL, requestBody) => {
  try {
    const otpRequestObj = {
      applicationId: requestBody?.applicationId,
    };
    const requestOTPResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.requestOtp}`,
      JSON.stringify(otpRequestObj)
    );
    if (requestOTPResponse?.status === 200 && requestOTPResponse.data) {
      return requestOTPResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default requestOTPService;
